// Wrapper around js-quantities that lets us rebuild the unit map (and the
// underlying Qty instance) without forcing every consumer to re-require.
const modulePath = require.resolve('js-quantities');

function freshQty() {
  delete require.cache[modulePath];
  return require('js-quantities');
}

let currentQty = freshQty();

function reload(customUnits) {
  currentQty = freshQty();
  if (Array.isArray(customUnits) && customUnits.length > 0) {
    currentQty.registerUnits(customUnits);
  }
  return currentQty;
}

const qtyProxy = function qtyProxy(...args) {
  return currentQty(...args);
};

module.exports = new Proxy(qtyProxy, {
  apply(_target, thisArg, args) {
    return currentQty.apply(thisArg, args);
  },
  get(_target, prop) {
    if (prop === 'reload') return reload;
    if (prop === 'getCurrent') return () => currentQty;
    const value = currentQty[prop];
    return typeof value === 'function' ? value.bind(currentQty) : value;
  },
  set(_target, prop, value) {
    currentQty[prop] = value;
    return true;
  },
});
